import { render, staticRenderFns } from "./AppEmailForm.vue?vue&type=template&id=127d1c87&scoped=true&"
import script from "./AppEmailForm.vue?vue&type=script&lang=js&"
export * from "./AppEmailForm.vue?vue&type=script&lang=js&"
import style0 from "./AppEmailForm.vue?vue&type=style&index=0&id=127d1c87&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127d1c87",
  null
  
)

export default component.exports